import { Outlet } from 'react-router-dom';

import { DecisionsSidebar } from '@/components/layout/Decisions/DecisionsSidebar';
import { DecisionsProvider } from '@/features/decisions';

export function DecisionsLayout() {
  return (
    <DecisionsProvider>
      <div className="flex flex-1 min-w-0 overflow-hidden">
        <DecisionsSidebar />
        <main className="flex-1 min-w-0 flex flex-col">
          <Outlet />
        </main>
      </div>
    </DecisionsProvider>
  );
}
